import React from 'react'
import { useTestMode } from '../Context/TextModeContext'

const Uppermenu = ({countDown}) => {

    const {settestTime}=useTestMode();

    const updateTime=(e)=>{
        settestTime(e.target.id)
    }
  return (
    <div className='upper-menu'>
    <div className='counter'>
        {countDown}
    <div className='modes'>
        <div className='time-modes' onClick={updateTime} id='15'>15s</div>
        <div className='time-modes' onClick={updateTime} id='30'>30s</div>
        <div className='time-modes' onClick={updateTime} id='60'>60sec</div>
    </div>
    </div>
    </div>
  )
}
export default Uppermenu;